/**
 * Shared nav group helpers for AppShell / SidebarNav.
 * Role shells still assemble items (badges, handlers); this documents the shape
 * and provides fixed SuperAdmin Admin item ids.
 */

export const SUPERADMIN_ADMIN_ITEM_IDS = [
  'users',
  'locations',
  'departments',
  'device-names',
  'complaint-categories',
  'data-import',
  'audit-viewer',
  'organization-settings',
  'system-controls',
];

/**
 * @typedef {{ id: string, label: string, icon: string, active?: boolean, badge?: number, onSelect: () => void }} NavItem
 * @typedef {{ id: string, label: string, items: NavItem[] }} NavGroup
 */

/**
 * Build Work + optional Admin groups, dropping empty groups.
 * @param {NavItem[]} workItems
 * @param {NavItem[]} [adminItems]
 * @returns {NavGroup[]}
 */
export function buildNavGroups(workItems = [], adminItems = []) {
  const groups = [];
  if (workItems.length) {
    groups.push({ id: 'work', label: 'Work', items: workItems });
  }
  if (adminItems.length) {
    groups.push({ id: 'admin', label: 'Admin', items: adminItems });
  }
  return groups;
}
